<template>
  <div
    class="common-date p-14-0 p-0-16 bg-FFFFFF fb fb-main-start fb-cross-center relative"
  >
    <div class="item-flex-1" @click="handlerToSelectTime(0)">
      <div class="font-30 c-191F25-40 text-bold-400">{{ label[0] }}</div>
      <div class="font-36 c-2F3135 text-bold-500 lh-28">{{ start }}</div>
    </div>
    <!-- <div class="item-flex-1 fb fb-cross-center fb-main-center">
      <i class="iconfont c-191F25-28 font-100">&#xe60c;</i>
    </div> -->
    <div class="item-flex-1 relative end-con" @click="handlerToSelectTime(1)">
      <div class="con">
        <div class="font-30 c-191F25-40 text-bold-400">结束时间</div>
        <div class="font-36 c-2F3135 text-bold-500 lh-28">
          <span
            v-if="+start.replace(':', '') >= +end.replace(':', '')"
            class="mr-4"
            >次日</span
          >
          <span>{{ end }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mcTimePicker } from '@/utils/mcSdkUtils'
import { timeFormat } from '@/utils/comUtils'
export default {
  components: {},
  props: {
    startTime: {
      type: String,
      default: '12:00'
    },
    endTime: {
      type: String,
      default: '15:00'
    },
    label: {
      type: Array,
      default() {
        return ['开始时间', '结束时间']
      }
    },
    crossHour: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      start: this.startTime,
      end: this.endTime
    }
  },
  computed: {},
  watch: {
    startTime() {
      this.start = this.startTime
    },
    endTime() {
      this.end = this.endTime
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerToSelectTime(index) {
      let defaultValue = index ? this.end : this.start
      let params = {
        minTime: `0${this.crossHour}`.slice(-2) + ':00',
        maxTime: '23:59',
        crossDay: index > 0 && this.crossHour > 0
      }
      const curren = new Date()
      const [startHour, startMinute] = this.start.split(':')
      const [endHour, endMinute] = this.end.split(':')
      const date = new Date(
        curren.getFullYear(),
        curren.getMonth(),
        curren.getDate(),
        index ? +startHour : +endHour,
        index ? +startMinute + 1 : +endMinute - 1
      )

      // eslint-disable-next-line
      params[index ? 'minTime' : 'maxTime'] = timeFormat(date, 'hh:mm')
      // 结束时间可能会跨天 结束时间点为开始时间+1天
      if (this.crossHour) {
        if (index) {
          date.setDate(date.getDate() + 1)
          date.setHours(this.crossHour - 1)
          date.setMinutes(59)
          params.maxTime = timeFormat(date, 'hh:mm')
        } else {
          date.setDate(curren.getDate())
          if (endHour < startHour) {
            date.setHours(23)
            date.setMinutes(59)
          }
          params.maxTime = timeFormat(date, 'hh:mm')
        }
      }
      setTimeout(() => {
        mcTimePicker({ defaultValue, ...params }).then(time => {
          this[index ? 'end' : 'start'] = time
          this.$emit('time-selection', {
            startTime: this.start,
            endTime: this.end
          })
        })
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-date {
  height: 79px;
  .end-con {
    .con {
      padding-left: 48px;
    }
    &:before {
      content: '\e60c';
      font-size: 50px;
      position: absolute;
      left: 0;
      top: 0;
      color: rgba(25, 31, 37, 0.28);
      font-family: 'iconfont';
      margin-left: -25px;
    }
  }
}
.ml-50 {
  margin-left: 50px;
}
</style>
